// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/shortcuts/types.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/shortcuts/src/types.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo comandero-app
//     node fleet/fleet.ts check --repo comandero-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
/**
 * Universal shortcut system — types.
 *
 * The model intentionally separates Commands (named actions) from KeyBindings
 * (key sequences that fire a command). Design record:
 * infra/fleet/artifacts/shortcuts/DESIGN.md (infra repo).
 */

export type Platform = "web" | "tauri-desktop" | "tauri-mobile" | "extension";

export type ScopeId =
  | "global"
  | "list"
  | "todo-detail"
  | "palette"
  | "overlay"
  | "dialog"
  | "input";

export const SCOPE_PRIORITY: Record<ScopeId, number> = {
  input: 60,
  dialog: 50,
  palette: 40,
  overlay: 30,
  "todo-detail": 30,
  list: 20,
  global: 10,
};

export interface WhenContext {
  "input.focused": boolean;
  "input.text-cursor": boolean;
  "dialog.open": boolean;
  "palette.open"?: boolean;
  "drawer.open"?: boolean;
  "todo.focused"?: boolean;
  "selection.active"?: boolean;
  [flag: string]: boolean | undefined;
}

export type WhenClause = string | ((ctx: WhenContext) => boolean);

export interface RunContext {
  event: KeyboardEvent;
  command: string;
  platform: Platform;
}

/**
 * Handler return values:
 *   - void / undefined: normal success
 *   - false: opt out; the engine warns since preventDefault has already fired
 *   - Promise: async handlers are awaited only for error logging
 */
// oxlint-disable-next-line typescript-eslint/no-invalid-void-type
export type CommandHandler = (ctx: RunContext) => void | boolean | Promise<void | boolean>;

export interface Command {
  id: string;
  category: string;
  titleKey: string;
  descriptionKey?: string;
  /** Default handler; can be overridden at registration time via useCommand. */
  run?: CommandHandler;
  /** Default when-clause for the command (further restricted by binding.when). */
  when?: WhenClause;
  /** Hide entirely on these platforms. */
  disabledOn?: readonly Platform[];
  /** Whether the dispatch should preventDefault on the original event. Default: true. */
  preventDefault?: boolean;
}

export interface KeyBinding {
  command: string;
  keys: string;
  when?: WhenClause;
  scope?: ScopeId;
  /** Higher value wins within the same scope on conflict. Default: 0. */
  priority?: number;
  source?: "default" | "user";
  platforms?: readonly Platform[];
}

export interface UserOverride {
  command: string;
  /** Empty string disables the command. */
  keys: string;
}

export interface PersistenceAdapter {
  load: () => Promise<UserOverride[]>;
  save: (overrides: readonly UserOverride[]) => Promise<void>;
}

export interface PlatformAdapter {
  id: Platform;
  isMac: boolean;
  reservedBindings: ReadonlySet<string>;
  formatKey: (key: string) => string;
  normalizeEvent: (event: KeyboardEvent) => string;
}

export interface ShortcutDispatchResult {
  matched: boolean;
  command?: string;
  reason?: "no-match" | "when-failed" | "platform-disabled" | "reserved" | "chord-progress";
}
